module.exports = __webpack_public_path__ + "img/house_and_funeral.c1b02f4f.svg";